var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 1707 1707",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M864 1706c-13 0-23-13-19-26l219-697c5-15 25-19 35-6l179 228c8 10 4 26-9 31l-143 55 51 115c4 7 2 17-4 22l-295 273c-4 3-9 5-14 5zm227-674-185 588 229-211-54-121c-5-11 0-23 11-27l138-53z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834 1706c-5 0-10-2-13-6l-287-272c-6-6-8-15-5-22l52-115-144-55c-12-5-16-21-8-31l179-228c10-13 30-9 35 7l212 702c0 15-11 18-21 20zm-262-297 221 211-177-588-139 176 138 53c11 4 16 16 11 27z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853 1256c-5 0-11-2-14-6l-230-247c-18-19 11-46 29-27l215 231 215-231c18-19 47 8 29 27l-229 247c-4 4-9 6-15 6zM1199 393c-11 0-20-9-20-20 0-174-143-332-301-332h-49c-158 0-302 158-302 332 0 27-40 27-40 0C487 178 650 1 829 1h49c179 0 341 177 341 372 0 11-9 20-20 20z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853 919c-169 0-307-138-307-307V377c0-154 125-280 279-280h57c154 0 279 126 279 280v235c0 169-138 307-308 307zm-28-782c-132 0-239 108-239 240v235c0 147 120 267 267 267 148 0 268-120 268-267V377c0-132-107-240-239-240z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141 498h-4c-296-70-357-307-555-29-15 21-48-2-33-24 221-308 320-51 597 14 23 5 19 39-5 39zM1019 1009c-9 0-17-6-19-16l-24-128c-5-26 34-33 39-7l24 128c2 12-7 23-20 23zm-332 0c-12 0-22-11-19-23l24-128c5-26 44-19 39 7l-24 128c-2 10-10 16-20 16z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476 1706H231c-31 0-55-25-55-55v-345c0-186 151-337 336-337h683c185 0 336 151 336 337v345c0 30-25 55-55 55zm-964-697c-163 0-297 133-297 297v345c0 8 7 15 16 15h1245c8 0 15-7 15-15v-345c0-164-133-297-296-297zM1042 551c-6 0-56-27-95-3-31 18-63-49 42-49 92 0 82 52 53 52z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 1706c-11 0-20-9-20-20v-262c0-26 40-26 40 0v262c0 11-9 20-20 20z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 1553H196c-27 0-27-40 0-40h224c27 0 27 40 0 40zM1286 1706c-11 0-20-9-20-20v-262c0-26 40-26 40 0v262c0 11-9 20-20 20z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511 1553h-225c-26 0-26-40 0-40h225c26 0 26 40 0 40z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4398d1",
    d: "M1306 1513h185v-207c0-164-133-297-296-297h-71l154 196c8 10 4 26-9 31l-143 55 51 115c4 7 2 17-4 22l-258 238h351v-242c0-26 40-26 40 0z",
    opacity: 1,
    "data-original": "#4398d1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4398d1",
    d: "M1491 1553h-185v113h170c8 0 15-7 15-15z",
    opacity: 1,
    "data-original": "#4398d1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#367ba9",
    d: "m906 1620 229-211-54-121c-5-11 0-23 11-27l138-53-139-176zM793 1620l-177-588-139 176 138 53c11 4 16 16 11 27l-54 121z",
    opacity: 1,
    "data-original": "#367ba9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaf6ff",
    d: "m668 1066 181 600 188-598-169 182c-8 8-21 8-29 0z",
    opacity: 1,
    "data-original": "#eaf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa978",
    d: "m670 1009 183 198 184-198z",
    opacity: 1,
    "data-original": "#ffa978"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4398d1",
    d: "m429 1205 154-196h-71c-163 0-297 133-297 297v207h185v-89c0-26 40-26 40 0v242h344l-250-238c-6-6-8-15-5-22l52-115-144-55c-12-5-16-21-8-31z",
    opacity: 1,
    "data-original": "#4398d1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4398d1",
    d: "M400 1553H215v98c0 8 7 15 16 15h169z",
    opacity: 1,
    "data-original": "#4398d1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa978",
    d: "M711 969h284l-14-77c-81 36-174 36-255 0z",
    opacity: 1,
    "data-original": "#ffa978"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbc85",
    d: "M853 879c146 0 268-118 268-267V494c-280-74-344-295-535-30v148c0 37 7 72 21 104h164c7-22 26-40 57-40 79 0 79 121 0 121-31 0-50-19-57-41H628c49 76 134 123 225 123zm189-328c-6 0-56-27-95-3-31 18-63-49 42-49 92 0 82 52 53 52zm-272 0c-6 0-56-27-95-3-31 18-63-49 42-49 92 0 82 52 53 52z",
    opacity: 1,
    "data-original": "#ffbc85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M586 399c189-226 292-16 535 53v-75c0-132-107-240-239-240h-57c-132 0-239 108-239 240z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566 619h-64c-47 0-85-38-85-85v-97c0-46 38-84 85-84 51 0 84-9 84 24 0 11-9 20-20 20-4 0-8-2-11-4h-53c-25 0-45 20-45 44 0 145-13 142 109 142 26 0 26 40 0 40z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 756H576c-52 0-94-42-94-94 0-41-9-83 20-83 28 0 20 42 20 83 0 30 24 54 54 54h211c27 0 27 40 0 40z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828 797c-80 0-80-121 0-121 79 0 79 121 0 121zm0-81c-27 0-27 41 0 41s27-41 0-41zM770 551c-6 0-56-27-95-3-31 18-63-49 42-49 92 0 82 52 53 52z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4e4e88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161 577c14 0 29 2 44 2 24 0 44-20 44-45v-97c0-27-20-44-50-44h-38zM828 757c27 0 27-41 0-41s-27 41 0 41zM546 579V393h-44c-25 0-45 20-45 44v97c0 47 48 46 89 45z",
    fill: "#4e4e88",
    opacity: 1,
    "data-original": "#4e4e88"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1205 619c-41 0-84 8-84-20 0-29 43-20 84-20 24 0 44-20 44-45v-97c0-24-20-44-44-44h-53c-14 5-31 5-31-18 0-30 43-22 84-22 46 0 84 38 84 84v97c0 47-38 85-84 85z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.52a8ca337ff4d92bb9cdbc83af30983e.svg";
export { ForwardRef as ReactComponent };